import { Box } from '@arpeggi/ui'
import { RouteObject } from 'react-router-dom'

const FallbackElement = () => (
  <Box column alignCenter justifyCenter css={{ width: '100%', height: '100%', minHeight: '90vh' }}>
    404 Page Not Found
  </Box>
)

export const FallbackRoute: RouteObject = {
  path: '*',
  element: <FallbackElement />
}
